export default __webpack_public_path__ + "static/media/card.0504a9ad.mp3";